import React, { useState } from "react"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { NEW_PROJECT_COLOR } from "shared/types/Project"
import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { useProjectColor } from "entities/projects/model/useProjectColor"

import "./styles/_project-image.scss"

export interface ProjectImageProps extends WithClassName {
  color: string | null | undefined
  isLoading?: boolean
}

export const ProjectImage = React.memo(
  ({ className, color = NEW_PROJECT_COLOR, isLoading }: ProjectImageProps) => {
    const [colorElement, setColorElement] = useState<HTMLElement | null>(null)
    useProjectColor({ element: colorElement, color })

    if (isLoading) {
      return (
        <Skeleton
          fill
          containerClassName={classNames(
            "project-image project-image--loading",
            className
          )}
        />
      )
    }

    return (
      <div
        className={classNames("project-image project-gradient", className)}
        ref={setColorElement}
        data-color={color}
        data-testid="project-image"
      >
        <Icon
          name={IconName.DQJ_INVERTED}
          className="project-info__schako-icon"
          size={IconSize.FLEX}
        />
      </div>
    )
  }
)

ProjectImage.displayName = "ProjectCardImage.Readonly"
